<template>
	<!-- 签到首页 -->
	<div>
		<!-- <van-nav-bar
			title="首单贡献值奖励"
			left-arrow
			@click-left="onClickLeft"/> -->
		<div class="">
			<van-tabs :before-change="navChange">
			  <van-tab v-for="(item,index) in navList" :key="index" :title="item.nm"></van-tab>
			</van-tabs>
			<div class="list">
				<div class="litem f-ac f-jsb" v-for="(item,index) in list" :key="item.user_id">
					<template v-if="type===1">
						<div class="">
							<div>会员：{{item.user_id}}</div>
							<div v-text="timeInit(item.crt_tm)"></div>
						</div>
						<div class="">
							<div>金额：￥{{item.total_amount}}</div>
							<div>贡献值+{{item.points}}</div>
						</div>
					</template>
					<template v-if="type===2">
						<div class="">
							<div>会员：{{item.id}}</div>
							<div v-text="timeInit(item.created_at)"></div>
						</div>
						<div class="not-odr">
							<div>未下单</div>
						</div>
					</template>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { Toast } from 'vant';
	export default {
	  name: "",
	  data() {
	    return {
		  isload:false,
		  dataSource: [],
		  navList:[
			  {nm:'已下单会员',id:0},
			  {nm:'未下单会员',id:1},
		  ],
		  userId:0,
		  list:[],
		  type:1,
	    };
	  },
	  created() {
		  this.userId = this.$route.query.userId;
		  this.getList();
	  },
	  mounted() {
	  	 document.querySelector('body').setAttribute('style', 'background-color:#ffffff');
		 document.querySelector('title').innerText = '首单贡献值奖励';
	  },
	methods: {
		navChange(res){
			console.log(res);
			this.type = res==0?1:2;
			this.getList();
			return true;
		},
		onClickLeft(){
			
			this.$router.push('/');
		},
		async getList(){
			Toast.loading({ message: '加载中...',forbidClick: true,loadingType: 'spinner'});
			let res = await this.$axios.get(`common/v1/system/selCtfOrders?userId=${this.userId}&types=${this.type}`);
			if(res.data.success){
				Toast.clear();
				console.log('get',res.data.data);
				this.list = res.data.data;
			}else{
				Toast.clear();
			}
		},
		timeInit(t){
			return this.$util.dateFormat(new Date(t),'yyyy-MM-dd hh:mm:ss')
		}
	}
};
</script>

<style lang="less" scoped>
	.list{
		overflow-y: scroll;
		height: calc(100% - 110px);//80vh;
		.litem{
			border: 0.0625rem solid #F8F8F8;
			padding: 0.625rem 0.9375rem;
			margin: 0.625rem 0.625rem 0;
			border-radius: 0.2875rem;
			&>div>div:nth-child(1){
				margin-bottom: 0.55rem;
			}
			.not-odr{
				width: 3.125rem;
				height: 3.125rem;
				display: flex;
				justify-content: center;
				align-items: center;
				border: 1px solid #F8F8F8;
				border-radius: 100px;
				font-size: 0.8125rem;
				div{
					margin-bottom: 0 !important;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/integral/new-user-odr.vue